import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { de } from "./locales/de";
import { en } from "./locales/en";

// =============================================================================
// Mehrsprachigkeit (Entscheidung 36): Deutsch Standard, Englisch von Beginn an
// =============================================================================
// Alle sichtbaren Texte laufen über Schlüssel: t("start.title"). Zahlen, Datum
// und Uhrzeit formatieren die Komponenten mit Intl in der aktiven Sprache.

export const LANGUAGES = ["de", "en"] as const;
export type Language = (typeof LANGUAGES)[number];

const LANGUAGE_KEY = "ortura.language";

// Gemerkte Wahl > Browsersprache (Englisch nur, wenn der Browser Englisch will) > Deutsch.
function initialLanguage(): Language {
  try {
    const stored = window.localStorage.getItem(LANGUAGE_KEY);
    if (stored === "de" || stored === "en") return stored;
  } catch {
    // localStorage gesperrt – Browsersprache verwenden
  }
  return navigator.language.toLowerCase().startsWith("en") ? "en" : "de";
}

export function changeLanguage(language: Language): void {
  void i18n.changeLanguage(language);
  document.documentElement.lang = language;
  try {
    window.localStorage.setItem(LANGUAGE_KEY, language);
  } catch {
    // ohne Merken
  }
}

const language = initialLanguage();
document.documentElement.lang = language;

void i18n.use(initReactI18next).init({
  resources: { de: { translation: de }, en: { translation: en } },
  lng: language,
  fallbackLng: "de",
  // React escaped Ausgaben selbst; doppeltes Escapen würde "&amp;" anzeigen.
  interpolation: { escapeValue: false },
});

export { i18n };
